import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 54173 104599"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#1c1b17;stroke-width:1515.93}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970061603280">
        <path
          d="M50690 54222 29179 29615c-1108-1266-3076-1266-4181 0L3488 54222c-947 1081-2730 412-2730-1025V31256c0-1175 426-2311 1199-3195L24998 1707c1105-1266 3074-1266 4181 0l23037 26354c773 886 1199 2020 1199 3195v21941c0 1437-1779 2106-2725 1025zM1762 68749c1136 1139 2980 1139 4117 0 1140-1138 1140-2983 0-4120-1137-1139-2981-1139-4117 0-1140 1135-1140 2982 0 4120zM9517 60992c1138 1139 2982 1139 4119 0 1140-1137 1140-2982 0-4120-1137-1139-2981-1139-4119 0-1140 1138-1140 2983 0 4120z"
          className="fill stroke1"
          style={{
            strokeWidth: 1515.93,
          }}
        />
        <path
          d="M17270 53238c1139 1137 2984 1137 4121 0 1140-1138 1140-2983 0-4120-1137-1140-2980-1140-4121 0-1137 1135-1137 2982 0 4120zM25027 45481c1140 1138 2984 1138 4121 0s1137-2983 0-4120-2981-1137-4121 0c-1137 1137-1137 2982 0 4120zM52416 68749c-1137 1139-2983 1139-4121 0-1137-1138-1137-2983 0-4120 1138-1139 2984-1139 4121 0 1137 1135 1137 2982 0 4120zM44659 60992c-1137 1139-2980 1139-4120 0-1138-1137-1138-2982 0-4120 1140-1139 2983-1139 4120 0 1139 1138 1139 2983 0 4120zM36905 53238c-1138 1137-2981 1137-4121 0-1137-1138-1137-2983 0-4120 1140-1140 2983-1140 4121 0 1137 1135 1137 2982 0 4120z"
          className="fill stroke1"
          style={{
            strokeWidth: 1515.93,
          }}
        />
        <path
          d="M29148 45481c-1137 1138-2981 1138-4121 0-1137-1138-1137-2983 0-4120 1140-1137 2984-1137 4121 0s1137 2982 0 4120zM1762 85869c1136 1138 2980 1138 4117 0 1140-1139 1140-2984 0-4121-1137-1138-2981-1138-4117 0-1140 1137-1140 2982 0 4121zM9517 78111c1138 1139 2982 1139 4119 0 1140-1136 1140-2981 0-4120-1137-1138-2981-1138-4119 0-1140 1139-1140 2984 0 4120zM17270 70356c1139 1138 2984 1138 4121 0 1140-1137 1140-2982 0-4120-1137-1139-2980-1139-4121 0-1137 1138-1137 2983 0 4120zM25027 62600c1140 1139 2984 1139 4121 0 1137-1138 1137-2983 0-4120-1137-1138-2981-1138-4121 0-1137 1137-1137 2982 0 4120zM52416 85869c-1137 1138-2983 1138-4121 0-1137-1139-1137-2984 0-4121 1138-1138 2984-1138 4121 0 1137 1137 1137 2982 0 4121zM44659 78111c-1137 1139-2980 1139-4120 0-1138-1136-1138-2981 0-4120 1140-1138 2983-1138 4120 0 1139 1139 1139 2984 0 4120zM36905 70356c-1138 1138-2981 1138-4121 0-1137-1137-1137-2982 0-4120 1140-1139 2983-1139 4121 0 1137 1138 1137 2983 0 4120z"
          className="fill stroke1"
          style={{
            strokeWidth: 1515.93,
          }}
        />
        <path
          d="M29148 62600c-1137 1139-2981 1139-4121 0-1137-1138-1137-2983 0-4120 1140-1138 2984-1138 4121 0 1137 1137 1137 2982 0 4120zM1762 102988c1136 1138 2980 1138 4117 0 1140-1139 1140-2983 0-4122-1137-1137-2981-1137-4117 0-1140 1139-1140 2983 0 4122zM9517 95232c1138 1139 2982 1139 4119 0 1140-1138 1140-2983 0-4120-1137-1138-2981-1138-4119 0-1140 1137-1140 2982 0 4120zM17270 87475c1139 1139 2984 1139 4121 0 1140-1137 1140-2981 0-4120-1137-1138-2980-1138-4121 0-1137 1139-1137 2983 0 4120zM25027 79720c1140 1138 2984 1138 4121 0 1137-1137 1137-2982 0-4119-1137-1140-2981-1140-4121 0-1137 1137-1137 2982 0 4119zM52416 102988c-1137 1138-2983 1138-4121 0-1137-1139-1137-2983 0-4122 1138-1137 2984-1137 4121 0 1137 1139 1137 2983 0 4122zM44659 95232c-1137 1139-2980 1139-4120 0-1138-1138-1138-2983 0-4120 1140-1138 2983-1138 4120 0 1139 1137 1139 2982 0 4120zM36905 87475c-1138 1139-2981 1139-4121 0-1137-1137-1137-2981 0-4120 1140-1138 2983-1138 4121 0 1137 1139 1137 2983 0 4120z"
          className="fill stroke1"
          style={{
            strokeWidth: 1515.93,
          }}
        />
        <path
          d="M29148 79720c-1137 1138-2981 1138-4121 0-1137-1137-1137-2982 0-4119 1140-1140 2984-1140 4121 0 1137 1137 1137 2982 0 4119z"
          className="fill stroke1"
          style={{
            strokeWidth: 1515.93,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
